// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
// import ElementUI from "element-ui"; // 全局引入

import "./directives/dialogDrag"; // 全局引入v - dialogDrag自定义指令
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/questionStyle.css";
import "./style/app-ui.css";

import "./assets/js/library.js";

//引入vuex文件
import store from "./store/store.js";
import pub from "@/assets/js/public.js";
import axios from "axios";

// 全局引入
// 引入echarts
// import * as echarts from "echarts";


// // 按需引入
// // 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
// import * as echarts from 'echarts/core';
// // 引入柱状图图表，图表后缀都为 Chart
// import { 
//   BarChart, // 柱状图
//   // LineChart, // 线形图
//   PieChart, // 饼图
//   // ScatterChart, // 散点图
//   // RadarChart, // 雷达图
//   // MapChart, // 地图图 用于展示地理区域（如国家、省份等）的数据分布情况
//   // GaugeChart, // 仪表盘图
//   // CandlestickChart, // K线图
//   // HeatmapChart, // 热力图
// } from 'echarts/charts';
// // 引入标题，提示框，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
// import {
//   TooltipComponent, // 鼠标悬停或其他操作时显示提示信息
//   GridComponent, // 非常常用，几乎所有基于直角坐标系的图表（如柱状图、折线图等）都需要这些组件
//   // GridSimpleComponent,
//   // TitleComponent, // 添加图表标题
//   // LegendComponent, // 展示图表的各类别信息
//   // DatasetComponent, // 提供脱离图表的纯数据容器
//   // TransformComponent, // 内置数据转换器组件

//   // 对图表数据区域进行缩放和平移
//   // DataZoomComponent,
//   // DataZoomInsideComponent, 
//   // DataZoomSliderComponent, 
// } from 'echarts/components';
// // 标签自动布局、全局过渡动画等特性
// // import { LabelLayout, UniversalTransition } from 'echarts/features';
// // 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步(选一个即可)
// import { 
//   // SVGRenderer,
//   CanvasRenderer
//  } from 'echarts/renderers';

// // 注册必须的组件
// echarts.use([
//   // TitleComponent,
//   TooltipComponent,
//   GridComponent,
//   // LegendComponent,
//   // DatasetComponent,
//   // TransformComponent,

//   BarChart,
//   // LineChart, 
//   PieChart, 
//   // ScatterChart, 
//   // RadarChart, 
//   // MapChart, 
//   // GaugeChart,
//   // CandlestickChart, 
//   // HeatmapChart, 
//   // LabelLayout,
//   // UniversalTransition,
//   CanvasRenderer
// ]);


// Vue.prototype.$echarts = echarts;

// Vue.use(ElementUI); // 全局引入

// 按需引入 element-ui 组件
import {
  Pagination,
  Dialog,
  Autocomplete,
  Menu,
  Submenu,
  MenuItem,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  Button,
  Table,
  TableColumn,
  DatePicker,
  Popover,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Row,
  Col,
  Upload,
  Progress,
  Carousel,
  CarouselItem,
  Cascader,
  Image,
  Loading,
  Spinner,
  Badge,
  Card,
  Rate,
  Steps,
  Step,
  Collapse,
  CollapseItem,
  ButtonGroup,
  OptionGroup,
  TimeSelect,
  TimePicker,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  MenuItemGroup,
  Tree,
  Alert,
  Slider,
  Icon,
  ColorPicker,
  Transfer,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Timeline,
  TimelineItem,
  Link,
  Divider,
  Calendar,
  Backtop,
  PageHeader,
  CascaderPanel,
  MessageBox,
  Message,
  Notification
} from 'element-ui';

// 按需引入
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(Popover);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Cascader);
Vue.use(Image);
Vue.use(Loading);
Vue.use(Spinner);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(OptionGroup);
Vue.use(ButtonGroup);
Vue.use(TimeSelect);
Vue.use(TimePicker);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(MenuItemGroup);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Slider);
Vue.use(Icon);
Vue.use(ColorPicker);
Vue.use(Transfer);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Link);
Vue.use(Divider);
Vue.use(Calendar);
Vue.use(Backtop);
Vue.use(PageHeader);
Vue.use(CascaderPanel);
// Vue.use(MessageBox);
// Vue.use(Message);
// Vue.use(Notification);
Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;

Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.prototype.store = store;
Vue.prototype.Src = pub.Src;
Vue.prototype.secondToDate = pub.secondToDate;
Vue.prototype.util = pub; // 公共JS方法
window.url = pub.Url;
window.hosturl = pub.Src;

// http request拦截器 添加一个请求拦截器
axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    let token = window.localStorage.getItem("token");
    if (!config.timeout) {
      config.timeout = 30000;
    }
    if (token) {
      // config.headers.accessToken = token;    //将token放到请求头发送给服务器
      config.headers.token = token; //将token放到请求头发送给服务器
      //这里经常搭配token使用，将token值配置到tokenkey中，将tokenkey放在请求头中
      // config.headers['accessToken'] = Token;
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
//增加响应拦截, 特别是201token过期.
axios.interceptors.response.use(
  (res) => {
    if (res.data.result === 201) {
      console.log("哈返回了.");
      let html = `<div style="position:fixed;background: rgba(0,0,0,.4);left:0;right:0;top:0;bottom:0;z-index:999999;">
      <div  style="width: 400px;background: #fff;position: absolute;top:50%;left:50%;transform: translate(-50%,-50%);padding: 20px;">
        <h2 style="font-weight: bold;font-size: 20px;margin-bottom: 20px;">提示</h2>
        <p>登录已过期,请重新登录</p>
        <div style="text-align: right">
          <a style="display:inline-block;width:50px;height:30px;background:#58a1ff;text-align: center;color:#fff;line-height: 30px;text-decoration: none" href="/">确定</a>
        </div>
      </div>
    </div>`;
      document.body.innerHTML = html;
    }
    return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// import Print from 'vue-print-nb'
// // Global instruction
// Vue.use(Print);

//注意文件路径

// router.beforeEach((to, from, next) => {
//   //to即将进入的目标路由对象，from当前导航正要离开的路由， next : 下一步执行的函数钩子
//   if (to.path === '/Login') {
//     next()
//   } // 如果即将进入登录路由，则直接放行
//   else {   //进入的不是登录路由
//     if (localStorage.getItem('user') == '' || localStorage.getItem('user') == null) {
//       next({path: '/Login'})
//     }
//     //下一跳路由需要登录验证，并且还未登录，则路由定向到 登录路由
//     else {
//       next()
//     }
//   }
//   //如果不需要登录验证，或者已经登录成功，则直接放行
// })

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js